export default [
    {
        path: '/rent/v2/couponOrder',
        name: 'couponOrder',
        component: () => import('@/pages/couponOrder/index'),
        meta: { title: '优惠券订单', requireAuth: true },
        children: [
          {
            path: 'couponProductDetail',
            name: 'couponProductDetail',
            component: () => import('@/pages/couponOrder/couponProductDetail'),
            meta: { title: '商品详情', requireAuth: true },
          },
          {
            path: 'idAuth',
            name: 'idAuth',
            component: () => import('@/pages/couponOrder/idAuth'),
            meta: { title: '权益人认证', requireAuth: true },
          },
          {
            path: 'authConfirm',
            name: 'authConfirm',
            component: () => import('@/pages/couponOrder/authConfirm'),
            meta: { title: '确认权益人信息', requireAuth: true },
          },
          {
            path: 'authDetail',
            name: 'authDetail',
            component: () => import('@/pages/couponOrder/authDetail'),
            meta: { title: '认证信息', requireAuth: true },
          },
        ]
    },
]



// WEBPACK FOOTER //
// ./src/pages/couponOrder/couponOrder.js